import { Routes } from 'src/constants/routes';

export const AGENT_ROUTE_PATHS = [Routes.AgentThread, Routes.Agent] as const;

/** Builds the dedicated full-page route for one opaque Agent thread id. */
export const getAgentThreadRoute = (threadId: string): string => `${Routes.Agent}/${encodeURIComponent(threadId)}`;

/** Returns the canonical full-page Agent route for a pristine or started thread. */
export const getAgentRouteForThread = (threadId: string, hasStartedConversation: boolean): string =>
  hasStartedConversation ? getAgentThreadRoute(threadId) : Routes.Agent;
